export default function () {
  if (this.$route.name === 'EditPlanCoupon') {
    this.loadCoupon()
  }
}
